import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Agency } from '../models/index';
import { isPlatformBrowser } from '@angular/common';
// import { CookieConsentService } from './../utils/cookie/cookie-consent.service';

declare var gtag: any;

/**
 *    eventCategory="contact"
 *    eventAction="click"
 *    eventLabel=„phone_click"
 *
 *    eventCategory="contact"
 *    eventAction="click"
 *    eventLabel=„email_click"
 *
 *    eventCategory="contact"
 *    eventAction="click"
 *    eventLabel=„maps_click"
 *
 *    eventCategory="social_media"
 *    eventAction="click"
 *    eventLabel=„facebook_click"
 *
 *    eventCategory="social_media"
 *    eventAction="click"
 *    eventLabel=„gplus_click"
 *
 *    eventCategory="social_media"
 *    eventAction="click"
 *    eventLabel=„instagram_click"
 *
 *    eventCategory="social_media"
 *    eventAction="click"
 *    eventLabel=„pinterest_click"
 *
 *    eventCategory="social_media"
 *    eventAction="click"
 *    eventLabel=„youtube_click"
 *
 *    eventCategory="contact"
 *    eventAction="message_sent"
 *    eventLabel=„contact_form_sent“
 *
 *    eventCategory="download"
 *    eventAction="click"
 *    eventLabel=leaflet_download
 */

@Injectable()
export class GtagService {

  static updatePhoneConversion(agency: Agency): void {
    if (environment.ads_phone_conversion_label) {
      if (typeof gtag === 'undefined') {
        throw new Error('Google Tag is not loaded.');
      }

      gtag('config', environment.ads_phone_conversion_label, {
        phone_conversion_number: agency.phone,
        phone_conversion_callback: (formattedNumber: string, mobileNumber: string) => {
          // tslint:disable:no-console
          console.log('phone_conversion_number', agency.phone, formattedNumber, mobileNumber);
          // tslint:enable
          agency.phone = mobileNumber;
        }
      });
    }
  }

  constructor(
    private router: Router,
    // private cookieConsentService: CookieConsentService,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject('WINDOW') private window: any
  ) {
    this.init();
  }

  init(): boolean {
    if (this.window && isPlatformBrowser(this.platformId)) {
      if (environment.analytics_tracking_id || environment.ads_tracking_id) {
        if (typeof gtag === 'undefined') {
          throw new Error('Google Tag is not loaded.');
        }

        // this.cookieConsentService.emitter.subscribe(consent => {
        //   if (consent === false)
        //     this.disableTracking();
        //   else
        //     this.enableTracking();
        // });

        // if (this.cookieConsentService.getConsent() === false)
        //   this.disableTracking();

        this.router.events.subscribe(event => {
          // http://blog.thecodecampus.de/angular-2-google-analytics-google-tag-manager/
          if (event instanceof NavigationEnd) {
            gtag('js', new Date());

            if (environment.analytics_tracking_id) {
              gtag('config', environment.analytics_tracking_id, {
                anonymize_ip: true,
                page_path: event.urlAfterRedirects
              });
            }
            if (environment.ads_tracking_id) {
              gtag('config', environment.ads_tracking_id, {
                anonymize_ip: true,
                page_path: event.urlAfterRedirects
              });
            }
          }
        });

        return true;
      }
    }

    return false;
  }

  // https://developers.google.com/analytics/devguides/collection/gtagjs/events
  sendEvent(eventCategory: string, eventAction: string, eventLabel: string, eventValue: string = null): boolean {
    if (!environment.analytics_tracking_id)
      return false;

    if (typeof gtag === 'undefined') {
      throw new Error('Google Tag is not loaded.');
    }

    if (isPlatformBrowser(this.platformId)) {
      gtag('event', eventAction, {
        event_category: eventCategory,
        event_label: eventLabel,
        anonymize_ip: true,
        value: eventValue
      });
    } else {
      return false;
    }

    return true;
  }

  disableTracking(): void {
    // document.cookie.split(';').forEach((c) => {
    //   document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    // });
    this.window['ga-disable-' + environment.analytics_tracking_id] = true;
    this.window['ga-disable-' + environment.ads_tracking_id] = true;
  }

  enableTracking(): void {
    this.window['ga-disable-' + environment.analytics_tracking_id] = false;
    this.window['ga-disable-' + environment.ads_tracking_id] = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/analytics/gtag.service.ts